/**
 * Stable hash of payload facts for cache / ReadingDocument.payloadHash (spec §9).
 * Excludes computedAt so the same chart yields the same hash across builds.
 */

/**
 * @param {object} payload - InterpretationPayload
 * @returns {string}
 */
export function hashPayload(payload) {
  const stable = {
    schemaVersion: payload.schemaVersion,
    meta: {
      displayName: payload.meta?.displayName ?? null,
      birth: payload.meta?.birth ?? null,
      settings: payload.meta?.settings ?? null,
    },
    angles: payload.angles,
    bodies: payload.bodies,
    nodes: payload.nodes,
    aspectsMajor: payload.aspectsMajor,
    derived: payload.derived,
    sectionPlan: payload.sectionPlan,
  };
  const json = JSON.stringify(stable, stableReplacer);
  return fnv1aHex(json);
}

/** @param {string} key @param {unknown} value */
function stableReplacer(key, value) {
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.round(value * 1e6) / 1e6;
  }
  return value;
}

/** FNV-1a 32-bit → 8-char hex */
function fnv1aHex(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return (h >>> 0).toString(16).padStart(8, "0");
}
